export const createFormDataFromObject = (value: object) => {
  return Object.entries(value).reduce((form, [key, value]) => {
    const data = value instanceof Array ? JSON.stringify(value) : value;
    form.append(key, data);
    return form;
  }, new FormData());
};
